import { render, staticRenderFns } from "./IssueSupplierReportView.vue?vue&type=template&id=0b2cc1b8&"
import script from "./IssueSupplierReportView.vue?vue&type=script&lang=js&"
export * from "./IssueSupplierReportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports